<template>
  <div class="top">
    <router-link to="/#home" class="logo">
      <svg @click="switchMenu(false)" viewBox="0 0 80 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_953_1416)">
          <path
              d="M65.108 40.0158C67.7439 40.0183 70.3544 39.5026 72.7897 38.4982C75.225 37.4938 77.4374 36.0206 79.2999 34.1629C79.3605 34.1012 79.4082 34.0281 79.44 33.9477C79.4718 33.8674 79.4871 33.7816 79.4851 33.6952C79.483 33.6089 79.4636 33.5239 79.4279 33.4452C79.3923 33.3665 79.3412 33.2957 79.2777 33.2369L78.2321 32.2552C78.1107 32.1404 77.9493 32.0769 77.7818 32.0781C77.6144 32.0794 77.4539 32.1453 77.3343 32.2619C74.0862 35.4779 69.6924 37.2831 65.1124 37.2831C60.5324 37.2831 56.1385 35.4779 52.8905 32.2619C52.7706 32.1454 52.61 32.0797 52.4425 32.0784C52.2749 32.0772 52.1134 32.1405 51.9917 32.2552L50.9403 33.2379C50.8767 33.2965 50.8255 33.3672 50.7898 33.4458C50.7541 33.5245 50.7347 33.6094 50.7326 33.6957C50.7305 33.782 50.7459 33.8678 50.7778 33.9481C50.8096 34.0283 50.8574 34.1014 50.9181 34.1629C52.7801 36.0207 54.9921 37.494 57.4272 38.4984C59.8622 39.5028 62.4724 40.0184 65.108 40.0158Z"
              fill="#00A0DF"/>
          <path
              d="M65.108 -0.0156147C67.7439 -0.0181106 70.3544 0.497609 72.7897 1.50197C75.225 2.50634 77.4374 3.9796 79.2999 5.83727C79.3605 5.89894 79.4082 5.9721 79.44 6.05242C79.4718 6.13274 79.4871 6.2186 79.4851 6.30492C79.483 6.39124 79.4636 6.47627 79.4279 6.55499C79.3923 6.63371 79.3412 6.70451 79.2777 6.76323L78.2321 7.74496C78.1107 7.85981 77.9493 7.92328 77.7818 7.92202C77.6144 7.92077 77.4539 7.85489 77.3343 7.73823C74.0862 4.52223 69.6924 2.71709 65.1124 2.71709C60.5324 2.71709 56.1385 4.52223 52.8905 7.73823C52.7706 7.85473 52.61 7.92049 52.4425 7.92174C52.2749 7.923 52.1134 7.85965 51.9917 7.74496L50.9403 6.76227C50.8767 6.70371 50.8255 6.63301 50.7898 6.55436C50.7541 6.47572 50.7347 6.39073 50.7326 6.30445C50.7305 6.21817 50.7459 6.13236 50.7778 6.05211C50.8096 5.97185 50.8574 5.8988 50.9181 5.83727C52.7801 3.97948 54.9921 2.50614 57.4272 1.50175C59.8622 0.497373 62.4724 -0.0182779 65.108 -0.0156147Z"
              fill="#00A0DF"/>
          <path
              d="M31.1857 14.9427C30.5835 14.5719 29.8864 14.3825 29.1786 14.3975C27.9834 14.3975 27.0501 14.7943 26.3788 15.5879V15.1744C26.3788 15.0022 26.3102 14.837 26.188 14.7151C26.0658 14.5933 25.9001 14.5247 25.7272 14.5244H24.3224C24.1495 14.5247 23.9838 14.5933 23.8616 14.7151C23.7394 14.837 23.6708 15.0022 23.6708 15.1744V24.9542C23.6708 25.1264 23.7394 25.2915 23.8617 25.4132C23.9839 25.5349 24.1496 25.6033 24.3224 25.6033H25.7947C25.9676 25.6033 26.1333 25.5349 26.2555 25.4132C26.3777 25.2915 26.4464 25.1264 26.4464 24.9542V18.9264C26.4464 18.2744 26.6395 17.7571 27.0257 17.3744C27.1857 17.2166 27.3757 17.0921 27.5845 17.0081C27.7934 16.9241 28.0169 16.8822 28.2421 16.885C28.6204 16.8849 28.9901 16.997 29.3041 17.2071C29.4302 17.2911 29.5817 17.3289 29.7327 17.3142C29.8838 17.2995 30.025 17.2331 30.1324 17.1264L31.3025 15.9485C31.3709 15.8793 31.4229 15.7957 31.4546 15.7038C31.4863 15.612 31.497 15.5142 31.4858 15.4177C31.4746 15.3213 31.4418 15.2285 31.3899 15.1463C31.3379 15.0641 31.2682 14.9945 31.1857 14.9427ZM9.71934 10.9302C9.89226 10.9302 10.0581 10.8618 10.1805 10.7402C10.3028 10.6185 10.3717 10.4534 10.372 10.2812V8.9427C10.3717 8.77047 10.3028 8.60539 10.1805 8.4837C10.0581 8.36201 9.89226 8.29366 9.71934 8.29366H1.01018C0.837348 8.29366 0.671594 8.36204 0.549383 8.48376C0.427172 8.60548 0.358514 8.77056 0.358514 8.9427V24.9542C0.358514 25.1264 0.427172 25.2915 0.549383 25.4132C0.671594 25.5349 0.837348 25.6033 1.01018 25.6033H2.67458C2.84742 25.6033 3.01317 25.5349 3.13538 25.4132C3.25759 25.2915 3.32625 25.1264 3.32625 24.9542V17.1658H8.67377C8.84661 17.1658 9.01236 17.0974 9.13457 16.9757C9.25678 16.854 9.32544 16.6889 9.32544 16.5167V15.1744C9.32544 15.0022 9.25681 14.837 9.13463 14.7151C9.01245 14.5933 8.84669 14.5247 8.67377 14.5244H3.32625V10.9302H9.71934ZM55.9915 14.3975C54.5627 14.3975 53.4041 14.743 52.5159 15.434C52.4439 15.4914 52.3849 15.5634 52.343 15.6453C52.301 15.7271 52.2771 15.8169 52.2727 15.9087C52.2683 16.0005 52.2836 16.0922 52.3175 16.1776C52.3515 16.263 52.4033 16.3403 52.4696 16.4042L53.3066 17.2177C53.4197 17.3266 53.5683 17.3913 53.7253 17.4002C53.8824 17.409 54.0373 17.3613 54.162 17.2658C54.6299 16.9126 55.205 16.736 55.8872 16.736C57.2678 16.736 57.9581 17.3174 57.9581 18.4802V19.0331H55.3321C54.0938 19.0331 53.1402 19.3449 52.4715 19.9687C51.8446 20.5494 51.5315 21.3078 51.5322 22.2437C51.5322 23.2648 51.8379 24.094 52.4493 24.7312C53.1039 25.3844 54.0506 25.7106 55.2896 25.71C56.3999 25.71 57.3106 25.3555 58.0218 24.6465V24.9542C58.0218 25.1264 58.0904 25.2915 58.2127 25.4132C58.3349 25.5349 58.5006 25.6033 58.6735 25.6033H60.082C60.2549 25.6033 60.4206 25.5349 60.5428 25.4132C60.665 25.2915 60.7337 25.1264 60.7337 24.9542V18.31C60.7324 15.701 59.1517 14.3969 55.9915 14.3975ZM57.9581 21.5206C57.9581 22.2014 57.8229 22.6693 57.5526 22.9244C57.1819 23.2783 56.5981 23.4555 55.8013 23.4562C54.7348 23.4562 54.2013 23.0308 54.2006 22.1802C54.2006 21.3437 54.72 20.9254 55.7588 20.9254H57.9581V21.5206ZM45.3814 14.3975C44.0575 14.3975 42.9472 14.8651 42.0507 15.8004C41.3671 14.8651 40.385 14.3975 39.1042 14.3975C37.9939 14.3975 37.0687 14.7802 36.3286 15.5456V15.1744C36.3286 15.0022 36.2599 14.837 36.1377 14.7151C36.0156 14.5933 35.8498 14.5247 35.6769 14.5244H34.2693C34.0964 14.5247 33.9306 14.5933 33.8084 14.7151C33.6862 14.837 33.6176 15.0022 33.6176 15.1744V24.9542C33.6176 25.1264 33.6863 25.2915 33.8085 25.4132C33.9307 25.5349 34.0965 25.6033 34.2693 25.6033H35.7406C35.9135 25.6033 36.0794 25.5349 36.2017 25.4132C36.3241 25.2915 36.393 25.1265 36.3932 24.9542V18.9052C36.3932 18.211 36.5924 17.6866 36.9908 17.3321C37.3178 17.034 37.7378 16.885 38.2507 16.885C38.7057 16.8695 39.1492 17.0297 39.4884 17.3321C39.8868 17.686 40.086 18.2103 40.086 18.9052V24.9542C40.086 25.1264 40.1547 25.2915 40.2769 25.4132C40.3991 25.5349 40.5648 25.6033 40.7377 25.6033H42.21C42.3828 25.6033 42.5485 25.5349 42.6708 25.4132C42.793 25.2915 42.8616 25.1264 42.8616 24.9542V18.8465C42.8616 18.1799 43.0682 17.6693 43.4814 17.3148C43.8269 17.0253 44.2679 16.8738 44.7191 16.8898C45.1745 16.8741 45.6183 17.0343 45.9578 17.3369C46.3555 17.6908 46.5547 18.2151 46.5554 18.91V24.959C46.5554 25.1312 46.624 25.2963 46.7462 25.418C46.8684 25.5397 47.0342 25.6081 47.207 25.6081H48.6793C48.8521 25.6081 49.0179 25.5397 49.1401 25.418C49.2623 25.2963 49.331 25.1312 49.331 24.959V18.5225C49.331 17.2334 48.9252 16.1844 48.1136 15.3754C47.459 14.7235 46.5483 14.3975 45.3814 14.3975ZM15.2802 19.0331C14.0419 19.0331 13.0884 19.3449 12.4196 19.9687C11.7928 20.5494 11.4796 21.3078 11.4803 22.2437C11.4803 23.2648 11.786 24.094 12.3974 24.7312C13.052 25.3844 13.9988 25.7106 15.2377 25.71C16.348 25.71 17.2587 25.3555 17.9699 24.6465V24.9542C17.9699 25.1264 18.0386 25.2915 18.1608 25.4132C18.283 25.5349 18.4487 25.6033 18.6216 25.6033H20.0301C20.203 25.6033 20.3687 25.5349 20.4909 25.4132C20.6131 25.2915 20.6818 25.1264 20.6818 24.9542V18.31C20.6818 15.701 19.1017 14.3969 15.9415 14.3975C14.5127 14.3975 13.3542 14.743 12.466 15.434C12.3939 15.4914 12.335 15.5634 12.293 15.6453C12.2511 15.7271 12.2271 15.8169 12.2227 15.9087C12.2184 16.0005 12.2336 16.0922 12.2676 16.1776C12.3016 16.263 12.3534 16.3403 12.4196 16.4042L13.2567 17.2177C13.3697 17.3266 13.5184 17.3913 13.6754 17.4002C13.8324 17.409 13.9874 17.3613 14.112 17.2658C14.58 16.9126 15.155 16.736 15.8373 16.736C17.2178 16.736 17.9081 17.3174 17.9081 18.4802V19.0331H15.2802ZM17.9062 21.5206C17.9062 22.2014 17.771 22.6693 17.5007 22.9244C17.13 23.2783 16.5462 23.4555 15.7494 23.4562C14.6823 23.4562 14.1487 23.0308 14.1487 22.1802C14.1487 21.3437 14.6681 20.9254 15.7069 20.9254H17.9062V21.5206ZM76.0474 28.9677L69.3579 19.8331L73.8597 15.6456C73.9562 15.5568 74.0236 15.4411 74.0529 15.3136C74.0822 15.186 74.0722 15.0526 74.0241 14.9309C73.9759 14.8092 73.892 14.7047 73.7832 14.6313C73.6745 14.5579 73.546 14.519 73.4146 14.5196H71.2607C71.0955 14.5196 70.9364 14.5822 70.8157 14.6946L66.4915 18.7215V6.04943C66.4915 5.87729 66.4229 5.71221 66.3007 5.59049C66.1784 5.46877 66.0127 5.40039 65.8399 5.40039H64.3734C64.2004 5.40039 64.0346 5.46874 63.9122 5.59043C63.7899 5.71212 63.721 5.87721 63.7207 6.04943V24.9542C63.721 25.1265 63.7899 25.2915 63.9122 25.4132C64.0346 25.5349 64.2004 25.6033 64.3734 25.6033H65.8399C66.0127 25.6033 66.1784 25.5349 66.3007 25.4132C66.4229 25.2915 66.4915 25.1264 66.4915 24.9542V22.5004L67.3189 21.7312L73.8085 30.5946C73.9103 30.7337 74.0634 30.8269 74.2341 30.8535C74.4049 30.8802 74.5792 30.8383 74.7189 30.7369L75.9045 29.8764C76.0443 29.7746 76.1378 29.6218 76.1646 29.4515C76.1914 29.2811 76.1492 29.1071 76.0474 28.9677ZM5.28608 29.5927H4.70682C4.69789 29.5925 4.68901 29.5941 4.68072 29.5974C4.67243 29.6007 4.66489 29.6057 4.65855 29.6119C4.65234 29.6177 4.64741 29.6247 4.64409 29.6325C4.64076 29.6403 4.63911 29.6487 4.63924 29.6571V32.1485L3.02504 29.6244C3.01908 29.6153 3.01073 29.608 3.0009 29.6033C2.99181 29.5976 2.9816 29.594 2.97097 29.5927H2.42454C2.41561 29.5925 2.40673 29.5941 2.39844 29.5974C2.39015 29.6007 2.38261 29.6057 2.37627 29.6119C2.37006 29.6177 2.36513 29.6247 2.36181 29.6325C2.35848 29.6403 2.35683 29.6487 2.35696 29.6571V33.4514C2.35687 33.4599 2.35854 33.4685 2.36186 33.4764C2.36517 33.4843 2.37008 33.4915 2.37627 33.4975C2.38265 33.5036 2.39023 33.5084 2.39852 33.5116C2.40682 33.5147 2.41567 33.5161 2.42454 33.5158H3.0038C3.01252 33.5161 3.02122 33.5147 3.02935 33.5115C3.03749 33.5084 3.04489 33.5036 3.0511 33.4975C3.06272 33.485 3.06895 33.4684 3.06848 33.4514V30.9619L4.68558 33.4879C4.6919 33.4966 4.69997 33.5039 4.70927 33.5094C4.71858 33.5149 4.72892 33.5183 4.73964 33.5196H5.28511C5.29399 33.5201 5.30287 33.5187 5.31119 33.5156C5.3195 33.5124 5.32706 33.5076 5.33338 33.5014C5.345 33.4888 5.35123 33.4723 5.35076 33.4552V29.6571C5.35119 29.6404 5.34494 29.6241 5.33338 29.6119C5.32722 29.6057 5.31985 29.6008 5.31172 29.5975C5.30358 29.5942 5.29486 29.5925 5.28608 29.5927ZM12.5992 29.5927H10.1625C10.1538 29.5927 10.1453 29.5944 10.1373 29.5977C10.1294 29.601 10.1222 29.6058 10.1161 29.6119C10.1101 29.6178 10.1053 29.6248 10.1022 29.6326C10.099 29.6404 10.0975 29.6487 10.0978 29.6571V33.4514C10.0975 33.4599 10.099 33.4684 10.1022 33.4763C10.1053 33.4843 10.1101 33.4915 10.1161 33.4975C10.1222 33.5035 10.1295 33.5082 10.1374 33.5113C10.1454 33.5145 10.1539 33.516 10.1625 33.5158H12.5992C12.6079 33.5161 12.6166 33.5147 12.6248 33.5115C12.6329 33.5084 12.6403 33.5036 12.6465 33.4975C12.6581 33.485 12.6644 33.4684 12.6639 33.4514V32.91C12.6646 32.9014 12.6635 32.8927 12.6605 32.8845C12.6575 32.8764 12.6527 32.869 12.6466 32.8628C12.6404 32.8567 12.633 32.852 12.6248 32.849C12.6166 32.846 12.6079 32.8449 12.5992 32.8456H10.8064V31.86H12.326C12.3344 31.8602 12.3428 31.8587 12.3506 31.8555C12.3584 31.8524 12.3655 31.8477 12.3714 31.8417C12.3776 31.8357 12.3825 31.8286 12.3858 31.8206C12.3891 31.8127 12.3908 31.8042 12.3907 31.7956V31.2812C12.3908 31.2726 12.3891 31.264 12.3858 31.2561C12.3825 31.2482 12.3776 31.241 12.3714 31.235C12.3655 31.229 12.3584 31.2243 12.3506 31.2212C12.3428 31.2181 12.3344 31.2165 12.326 31.2167H10.8064V30.2658H12.5992C12.6167 30.2664 12.6336 30.2602 12.6465 30.2485C12.6524 30.2422 12.657 30.2348 12.66 30.2267C12.663 30.2186 12.6643 30.21 12.6639 30.2014V29.6571C12.6642 29.6486 12.6627 29.6401 12.6595 29.6322C12.6564 29.6242 12.6516 29.617 12.6456 29.611C12.6395 29.6049 12.6323 29.6002 12.6243 29.5971C12.6163 29.5939 12.6078 29.5924 12.5992 29.5927ZM9.06767 29.5927H6.40405C6.39542 29.5926 6.38686 29.5943 6.37889 29.5976C6.37093 29.6009 6.36372 29.6058 6.3577 29.6119C6.35167 29.6178 6.34693 29.6248 6.34377 29.6326C6.34061 29.6404 6.33911 29.6487 6.33936 29.6571V30.1687C6.33909 30.1772 6.34058 30.1857 6.34374 30.1936C6.3469 30.2016 6.35165 30.2088 6.35771 30.2148C6.36377 30.2208 6.37101 30.2256 6.37898 30.2287C6.38695 30.2319 6.39548 30.2334 6.40405 30.2331H7.38299V33.4514C7.38266 33.46 7.38422 33.4686 7.38755 33.4765C7.39089 33.4845 7.39592 33.4917 7.4023 33.4975C7.40822 33.5035 7.41529 33.5082 7.42309 33.5113C7.4309 33.5144 7.43926 33.516 7.44768 33.5158H8.02693C8.0355 33.516 8.04403 33.5146 8.052 33.5114C8.05997 33.5083 8.06721 33.5035 8.07327 33.4975C8.07946 33.4915 8.08437 33.4843 8.08769 33.4764C8.09101 33.4685 8.09267 33.4599 8.09258 33.4514V30.2331H9.07153C9.07995 30.2333 9.08831 30.2318 9.09611 30.2286C9.10392 30.2255 9.11099 30.2208 9.11691 30.2148C9.1231 30.2088 9.128 30.2016 9.13132 30.1937C9.13464 30.1858 9.1363 30.1773 9.13622 30.1687V29.6571C9.13634 29.6487 9.13469 29.6403 9.13137 29.6325C9.12804 29.6247 9.12312 29.6177 9.11691 29.6119C9.1106 29.6053 9.10293 29.6002 9.09442 29.5969C9.08592 29.5936 9.07679 29.5921 9.06767 29.5927ZM0.965771 29.5927H0.386512C0.378037 29.5927 0.369646 29.5944 0.361848 29.5977C0.354049 29.601 0.347004 29.6058 0.341136 29.6119C0.334778 29.6176 0.32975 29.6246 0.326412 29.6324C0.323075 29.6402 0.32151 29.6486 0.321828 29.6571V33.4514C0.321499 33.46 0.323056 33.4686 0.32639 33.4765C0.329723 33.4845 0.334755 33.4917 0.341136 33.4975C0.347052 33.5035 0.354128 33.5082 0.36193 33.5113C0.369733 33.5144 0.378098 33.516 0.386512 33.5158H0.965771C0.974184 33.516 0.982549 33.5144 0.990352 33.5113C0.998155 33.5082 1.00523 33.5035 1.01115 33.4975C1.01733 33.4915 1.02224 33.4843 1.02556 33.4764C1.02888 33.4685 1.03054 33.4599 1.03045 33.4514V29.6571C1.03058 29.6487 1.02893 29.6403 1.02561 29.6325C1.02228 29.6247 1.01735 29.6177 1.01115 29.6119C1.00528 29.6058 0.998233 29.601 0.990434 29.5977C0.982636 29.5944 0.974246 29.5927 0.965771 29.5927ZM15.8334 31.8042C15.934 31.7612 16.0287 31.7056 16.1153 31.6389C16.2013 31.5733 16.2766 31.4948 16.3383 31.4062C16.4776 31.2043 16.5511 30.9646 16.5488 30.7196C16.5492 30.6333 16.5382 30.5473 16.516 30.4639C16.4952 30.3826 16.4654 30.3039 16.4272 30.2292C16.3906 30.1572 16.3469 30.0889 16.2968 30.0254C16.2507 29.9658 16.1993 29.9105 16.1433 29.86C16.0361 29.7751 15.9144 29.71 15.7842 29.6677C15.6366 29.6191 15.482 29.595 15.3266 29.5965H13.8379C13.8292 29.5965 13.8207 29.5981 13.8127 29.6014C13.8047 29.6047 13.7975 29.6096 13.7915 29.6158C13.7855 29.6216 13.7807 29.6287 13.7776 29.6365C13.7744 29.6442 13.7729 29.6526 13.7732 29.661V33.4552C13.7729 33.4637 13.7744 33.4722 13.7776 33.4802C13.7807 33.4881 13.7855 33.4953 13.7915 33.5013C13.7976 33.5074 13.8048 33.5121 13.8128 33.5153C13.8208 33.5184 13.8293 33.5199 13.8379 33.5196H14.4171C14.4257 33.5199 14.4342 33.5184 14.4422 33.5153C14.4502 33.5121 14.4574 33.5074 14.4635 33.5013C14.4695 33.4953 14.4743 33.4881 14.4774 33.4802C14.4806 33.4722 14.4821 33.4637 14.4818 33.4552V31.8975H15.1151L15.8826 33.4792C15.8888 33.4899 15.8978 33.4985 15.9087 33.5042C15.9198 33.5111 15.9324 33.5151 15.9454 33.5158H16.6289C16.6401 33.5164 16.6513 33.514 16.6613 33.509C16.6713 33.5039 16.6798 33.4963 16.6859 33.4869C16.692 33.4768 16.6953 33.4651 16.6953 33.4533C16.6953 33.4414 16.692 33.4298 16.6859 33.4196L15.8334 31.8042ZM15.286 31.2504H14.477V30.2331H15.3188C15.3911 30.2325 15.4631 30.2412 15.5332 30.259C15.5944 30.2738 15.6519 30.301 15.7021 30.3389C15.7544 30.3805 15.7961 30.4339 15.8238 30.4946C15.8542 30.5653 15.869 30.6417 15.8672 30.7187C15.8682 30.8581 15.8161 30.9928 15.7214 31.0956C15.6646 31.1515 15.5962 31.1944 15.521 31.2211C15.4457 31.2479 15.3655 31.2579 15.286 31.2504ZM38.4371 29.5889H37.8578C37.8487 29.5885 37.8396 29.5901 37.8312 29.5934C37.8227 29.5967 37.815 29.6017 37.8086 29.6081C37.8025 29.6139 37.7978 29.621 37.7946 29.6288C37.7915 29.6365 37.79 29.6449 37.7902 29.6533V32.1446L36.1779 29.6206C36.1722 29.6113 36.1638 29.6039 36.1538 29.5994C36.1448 29.5936 36.1345 29.59 36.1239 29.5889H35.5784C35.5693 29.5885 35.5603 29.5901 35.5518 29.5934C35.5433 29.5967 35.5356 29.6017 35.5292 29.6081C35.5231 29.6139 35.5184 29.621 35.5152 29.6288C35.5121 29.6365 35.5106 29.6449 35.5108 29.6533V33.4475C35.5106 33.456 35.5121 33.4645 35.5152 33.4725C35.5184 33.4804 35.5231 33.4876 35.5292 33.4937C35.5357 33.4999 35.5434 33.5047 35.5519 33.5078C35.5604 33.511 35.5694 33.5124 35.5784 33.5119H36.1577C36.1664 33.5125 36.1752 33.5111 36.1833 33.5079C36.1915 33.5048 36.1989 33.4999 36.205 33.4937C36.2166 33.4811 36.2228 33.4646 36.2224 33.4475V30.9619L37.8395 33.4879C37.8452 33.4968 37.8532 33.5041 37.8626 33.509C37.8716 33.5155 37.8824 33.5192 37.8935 33.5196H38.4399C38.4487 33.5201 38.4574 33.5188 38.4656 33.5156C38.4738 33.5125 38.4812 33.5076 38.4873 33.5014C38.4989 33.4888 38.5051 33.4723 38.5046 33.4552V29.6571C38.5051 29.6404 38.4988 29.6241 38.4873 29.6119C38.481 29.6052 38.4734 29.6 38.4648 29.5967C38.4563 29.5934 38.4472 29.592 38.438 29.5927L38.4371 29.5889ZM41.455 29.5956C41.445 29.588 41.4328 29.5836 41.4202 29.5831H40.9443C40.9307 29.5832 40.9176 29.5876 40.9066 29.5956C40.8945 29.6021 40.8855 29.6132 40.8815 29.6264L39.4923 33.4206C39.4869 33.4301 39.4842 33.4409 39.4842 33.4518C39.4842 33.4628 39.4869 33.4735 39.4923 33.4831C39.4982 33.4921 39.5064 33.4994 39.5161 33.5041C39.5257 33.5088 39.5365 33.5109 39.5473 33.51H40.1584C40.1717 33.5092 40.1844 33.5045 40.1951 33.4965C40.2066 33.4894 40.2157 33.479 40.2212 33.4667C40.2675 33.334 40.3177 33.1985 40.3641 33.06C40.4104 32.9215 40.4606 32.786 40.5079 32.6533H41.8595L42.1385 33.4667C42.1432 33.4792 42.1521 33.4897 42.1636 33.4965C42.1753 33.5047 42.189 33.5093 42.2032 33.51H42.8085C42.8194 33.5108 42.8303 33.5088 42.8402 33.5041C42.85 33.4993 42.8584 33.4921 42.8645 33.4831C42.8696 33.4734 42.8722 33.4627 42.8722 33.4518C42.8722 33.4409 42.8696 33.4302 42.8645 33.4206L41.4753 29.6264C41.4717 29.6156 41.465 29.6063 41.456 29.5994L41.455 29.5956ZM41.5651 31.784C41.5931 31.8629 41.6201 31.9398 41.6471 32.0148H40.7251L40.8767 31.5792C40.8999 31.5148 40.9211 31.4523 40.9404 31.3946C40.9597 31.3369 40.9771 31.2812 40.9954 31.2283L41.1036 30.9052L41.1876 30.6494L41.2629 30.884L41.3594 31.1965L41.4811 31.5514C41.511 31.635 41.5371 31.7081 41.566 31.7879L41.5651 31.784ZM20.6654 29.5927H20.0861C20.0771 29.5925 20.068 29.5941 20.0596 29.5974C20.0511 29.6007 20.0434 29.6056 20.0369 29.6119C20.0309 29.6178 20.0261 29.6248 20.023 29.6326C20.0198 29.6404 20.0183 29.6487 20.0186 29.6571V32.1485L18.4072 29.6244C18.4012 29.6151 18.3924 29.6077 18.3822 29.6033C18.3734 29.5977 18.3635 29.5941 18.3532 29.5927H17.8068C17.7977 29.5924 17.7886 29.5939 17.7801 29.5972C17.7717 29.6005 17.764 29.6055 17.7575 29.6119C17.7515 29.6178 17.7467 29.6248 17.7436 29.6326C17.7404 29.6404 17.7389 29.6487 17.7392 29.6571V33.4514C17.7389 33.4599 17.7404 33.4684 17.7435 33.4763C17.7467 33.4843 17.7515 33.4915 17.7575 33.4975C17.7641 33.5037 17.7718 33.5085 17.7803 33.5117C17.7887 33.5148 17.7977 33.5162 17.8068 33.5158H18.386C18.3948 33.5163 18.4035 33.5149 18.4117 33.5118C18.4198 33.5086 18.4272 33.5038 18.4333 33.4975C18.4393 33.4914 18.4439 33.4842 18.4469 33.4762C18.4498 33.4683 18.4511 33.4598 18.4507 33.4514V30.9619L20.0688 33.4879C20.0739 33.497 20.0816 33.5044 20.091 33.509C20.1003 33.5157 20.1114 33.5194 20.1228 33.5196H20.6683C20.677 33.5201 20.6858 33.5188 20.6939 33.5156C20.7021 33.5125 20.7095 33.5076 20.7156 33.5014C20.7272 33.4888 20.7335 33.4723 20.733 33.4552V29.6571C20.7334 29.6404 20.7272 29.6241 20.7156 29.6119C20.7093 29.6051 20.7015 29.5998 20.6927 29.5965C20.684 29.5932 20.6747 29.5919 20.6654 29.5927ZM46.4318 32.8456H44.6351V29.6571C44.6354 29.6486 44.6339 29.6402 44.6305 29.6324C44.6272 29.6246 44.6222 29.6176 44.6158 29.6119C44.6099 29.6058 44.6029 29.601 44.5951 29.5977C44.5873 29.5944 44.5789 29.5927 44.5704 29.5927H43.9912C43.9826 29.5926 43.974 29.5943 43.966 29.5976C43.9581 29.6009 43.9509 29.6058 43.9448 29.6119C43.9386 29.6177 43.9337 29.6247 43.9304 29.6325C43.9271 29.6403 43.9254 29.6487 43.9255 29.6571V33.4514C43.9254 33.4599 43.9271 33.4685 43.9304 33.4764C43.9338 33.4843 43.9386 33.4915 43.9448 33.4975C43.9509 33.5035 43.9581 33.5083 43.9661 33.5114C43.9741 33.5146 43.9826 33.516 43.9912 33.5158H46.427C46.4357 33.5163 46.4445 33.5149 46.4526 33.5118C46.4608 33.5086 46.4682 33.5038 46.4743 33.4975C46.4859 33.485 46.4921 33.4684 46.4916 33.4514V32.91C46.4923 32.8926 46.486 32.8757 46.4743 32.8629C46.4628 32.8521 46.4476 32.8459 46.4318 32.8456ZM34.2249 30.6619C34.2127 30.5942 34.1949 30.5277 34.1718 30.4629C34.1489 30.3989 34.1214 30.3365 34.0897 30.2764C34.0369 30.1842 33.9719 30.0995 33.8966 30.0244C33.8137 29.9392 33.7243 29.8604 33.6292 29.7889C33.5186 29.714 33.3971 29.6563 33.2691 29.6177C33.1296 29.5772 32.9848 29.5571 32.8395 29.5581C32.5568 29.5494 32.2786 29.6302 32.0449 29.7889C31.9474 29.8596 31.8569 29.9394 31.7746 30.0273C31.6044 30.2013 31.4909 30.4225 31.4493 30.6619C31.4353 30.7691 31.4269 30.877 31.4242 30.985C31.4171 31.1318 31.4139 31.3219 31.4145 31.5552C31.4145 31.7889 31.4145 31.9802 31.4242 32.1264C31.4268 32.2344 31.4352 32.3423 31.4493 32.4494C31.4752 32.5839 31.5218 32.7137 31.5873 32.834C31.6393 32.9253 31.7022 33.0098 31.7746 33.086C31.8558 33.1733 31.9464 33.2513 32.0449 33.3187C32.2819 33.4682 32.5566 33.5476 32.8371 33.5476C33.1176 33.5476 33.3923 33.4682 33.6292 33.3187C33.8184 33.195 33.9774 33.0307 34.0945 32.8379C34.1263 32.778 34.1537 32.716 34.1766 32.6523C34.1996 32.5872 34.2174 32.5203 34.2297 32.4523C34.2461 32.3453 34.2555 32.2374 34.2577 32.1292C34.2645 31.9831 34.2674 31.7917 34.2674 31.5581C34.2674 31.3244 34.2674 31.135 34.2577 30.9879C34.2539 30.8786 34.2429 30.7698 34.2249 30.6619ZM33.5134 32.3014C33.5011 32.3533 33.4836 32.4039 33.4612 32.4523C33.4374 32.5023 33.4079 32.5494 33.3734 32.5927C33.3149 32.666 33.242 32.7265 33.159 32.7706C33.0602 32.8228 32.9494 32.8486 32.8376 32.8456C32.7338 32.8486 32.6309 32.8272 32.537 32.7833C32.4431 32.7394 32.3608 32.6741 32.2969 32.5927C32.2289 32.5061 32.1808 32.4056 32.156 32.2985C32.1417 32.2103 32.1333 32.1214 32.1309 32.0321C32.1241 31.9081 32.1212 31.7437 32.1212 31.5514C32.1212 31.359 32.1212 31.1965 32.1309 31.0706C32.1335 30.981 32.1419 30.8918 32.156 30.8033C32.1711 30.7503 32.1901 30.6986 32.2129 30.6485C32.2356 30.5981 32.2648 30.5509 32.2998 30.5081C32.3286 30.4728 32.361 30.4406 32.3964 30.4119C32.4343 30.3812 32.4754 30.3544 32.519 30.3321C32.5658 30.3132 32.6142 30.2987 32.6638 30.2889C32.7766 30.2606 32.8947 30.2606 33.0075 30.2889C33.0585 30.3027 33.108 30.3217 33.1552 30.3456C33.198 30.3681 33.2384 30.3949 33.2759 30.4254C33.3112 30.4541 33.3436 30.4863 33.3724 30.5215C33.4054 30.5654 33.4339 30.6124 33.4574 30.6619C33.4808 30.7116 33.4992 30.7634 33.5124 30.8167C33.5484 31.0628 33.562 31.3115 33.5529 31.56C33.5624 31.8078 33.5492 32.056 33.5134 32.3014ZM30.1469 29.5927H29.5676C29.5592 29.5927 29.5508 29.5944 29.543 29.5977C29.5352 29.601 29.5281 29.6058 29.5223 29.6119C29.5161 29.6177 29.5111 29.6247 29.5078 29.6325C29.5045 29.6403 29.5028 29.6487 29.503 29.6571V33.4514C29.5029 33.4599 29.5045 33.4685 29.5079 33.4764C29.5112 33.4843 29.5161 33.4915 29.5223 33.4975C29.5282 33.5035 29.5353 33.5082 29.5431 33.5113C29.5509 33.5144 29.5592 33.516 29.5676 33.5158H30.1469C30.1642 33.516 30.1808 33.5094 30.1932 33.4975C30.1993 33.4915 30.2041 33.4843 30.2072 33.4763C30.2104 33.4684 30.2119 33.4599 30.2116 33.4514V29.6571C30.2118 29.6487 30.2103 29.6404 30.2072 29.6326C30.204 29.6248 30.1993 29.6178 30.1932 29.6119C30.1809 29.5997 30.1643 29.5928 30.1469 29.5927ZM23.6833 29.5994C23.6733 29.5918 23.6612 29.5875 23.6486 29.5869H23.1726C23.1591 29.5871 23.1459 29.5914 23.135 29.5994C23.1291 29.6027 23.1239 29.6071 23.1198 29.6124C23.1156 29.6177 23.1126 29.6237 23.1108 29.6302L21.7206 33.4244C21.7155 33.4341 21.7129 33.4448 21.7129 33.4557C21.7129 33.4666 21.7155 33.4773 21.7206 33.4869C21.7267 33.4959 21.7351 33.5032 21.745 33.5079C21.7548 33.5126 21.7657 33.5147 21.7766 33.5139H22.3877C22.4007 33.5128 22.4131 33.5082 22.4234 33.5004C22.4349 33.4933 22.444 33.4829 22.4495 33.4706C22.4968 33.3379 22.5461 33.2023 22.5924 33.0639C22.6387 32.9254 22.6889 32.7898 22.7362 32.6571H24.0879L24.3669 33.4706C24.3724 33.4829 24.3814 33.4933 24.3929 33.5004C24.4042 33.5085 24.4176 33.5132 24.4315 33.5139H25.0369C25.0476 33.5147 25.0584 33.5127 25.0681 33.5079C25.0778 33.5032 25.086 33.4959 25.0919 33.4869C25.097 33.4773 25.0996 33.4666 25.0996 33.4557C25.0996 33.4448 25.097 33.4341 25.0919 33.4244L23.7026 29.6302C23.7003 29.6183 23.6943 29.6075 23.6853 29.5994H23.6833ZM23.7934 31.7879C23.8214 31.8667 23.8484 31.9437 23.8755 32.0187H22.9535L23.105 31.5831C23.1282 31.5187 23.1494 31.4562 23.1688 31.3985L23.2238 31.2321L23.3319 30.909L23.4159 30.6533L23.4922 30.8879L23.5887 31.2004L23.7104 31.5552C23.7384 31.635 23.7654 31.7081 23.7934 31.7879ZM28.4893 29.5927H25.8227C25.8054 29.5928 25.7887 29.5997 25.7764 29.6119C25.7704 29.6178 25.7656 29.6248 25.7625 29.6326C25.7593 29.6404 25.7578 29.6487 25.758 29.6571V30.1687C25.7578 30.1772 25.7593 30.1857 25.7624 30.1936C25.7656 30.2016 25.7703 30.2088 25.7764 30.2148C25.7888 30.2267 25.8055 30.2333 25.8227 30.2331H26.8017V33.4514C26.8016 33.4599 26.8033 33.4685 26.8066 33.4764C26.8099 33.4843 26.8148 33.4915 26.821 33.4975C26.8269 33.5035 26.834 33.5082 26.8418 33.5113C26.8496 33.5144 26.8579 33.516 26.8664 33.5158H27.4456C27.454 33.516 27.4624 33.5144 27.4702 33.5113C27.478 33.5082 27.4851 33.5035 27.491 33.4975C27.4972 33.4915 27.5021 33.4843 27.5054 33.4764C27.5087 33.4685 27.5104 33.4599 27.5103 33.4514V30.2331H28.4893C28.4977 30.2333 28.506 30.2318 28.5138 30.2286C28.5216 30.2255 28.5287 30.2208 28.5346 30.2148C28.541 30.209 28.546 30.2018 28.5494 30.1939C28.5527 30.1859 28.5543 30.1773 28.5539 30.1687V29.6571C28.5543 29.6486 28.5527 29.6402 28.5494 29.6324C28.546 29.6246 28.541 29.6176 28.5346 29.6119C28.5288 29.6058 28.5217 29.601 28.5139 29.5977C28.5061 29.5944 28.4977 29.5927 28.4893 29.5927Z"
              fill="#1E1E1C"/>
        </g>
        <defs>
          <clipPath id="clip0_953_1416">
            <rect width="79.4872" height="40" fill="white"/>
          </clipPath>
        </defs>
      </svg>

    </router-link>
    <nav class="links" @click="switchMenu(false)">
      <router-link :class="[{ activeLink: getActiveLink === 'home' }]" to="/#home">Home</router-link>
      <router-link :class="[{ activeLink: getActiveLink === 'about-us' }]" to="/#about-us">about us</router-link>
      <router-link :class="[{ activeLink: getActiveLink === 'management' }]" to="/#management">MANAGEMENT</router-link>
      <a href="https://farmak.ch/products-uk-ireland/" target="_blank">products</a>
      <a class="drop-desk"
         :class="[{ activeLink: getActiveLink === 'carbon-statement' || getActiveLink === 'slavery-statement-2024' },{activeDrop:menuDrop }]">
        <span @click="menuDrop = !menuDrop">Statements</span>
        <svg width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.987183 0L3.98718 4L6.98718 0H0.987183Z" fill="#63666A"/>
        </svg>
        <div class="drop-desk__hide">
          <a @click=" goToLink('carbon-statement')"
             :class="[{ activeLink: getActiveLink === 'carbon-statement' }]">
            Carbon Emissions Statement
          </a>
          <a @click=" goToLink('slavery-statement-2024')"
             :class="[{ activeLink: getActiveLink === 'slavery-statement-2024' }]">
            Modern Slavery Statement for
            the Financial Year 2024
          </a>
        </div>
      </a>
      <router-link :class="[{ activeLink: getActiveLink === 'contact' }]" to="/#contact">Contact</router-link>
    </nav>

    <svg v-if="!getOpenMenu" @click="switchMenu(true)" class="mob-btn" viewBox="0 0 81 36" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
          d="M13.4062 21V13.8418H15.5693L16.8682 18.7246L18.1523 13.8418H20.3203V21H18.9775V15.3652L17.5566 21H16.165L14.749 15.3652V21H13.4062ZM21.7559 21V13.8418H27.0635V15.0527H23.2012V16.6396H26.7949V17.8457H23.2012V19.7939H27.2002V21H21.7559ZM28.4404 21V13.8418H29.8467L32.7764 18.6221V13.8418H34.1191V21H32.6689L29.7832 16.332V21H28.4404ZM35.6426 13.8418H37.0879V17.7188C37.0879 18.334 37.1058 18.7327 37.1416 18.915C37.2035 19.208 37.3499 19.444 37.5811 19.623C37.8154 19.7988 38.1344 19.8867 38.5381 19.8867C38.9482 19.8867 39.2575 19.8037 39.4658 19.6377C39.6742 19.4684 39.7995 19.2617 39.8418 19.0176C39.8841 18.7734 39.9053 18.3682 39.9053 17.8018V13.8418H41.3506V17.6016C41.3506 18.4609 41.3115 19.068 41.2334 19.4229C41.1553 19.7777 41.0104 20.0771 40.7988 20.3213C40.5905 20.5654 40.3105 20.7607 39.959 20.9072C39.6074 21.0505 39.1484 21.1221 38.582 21.1221C37.8984 21.1221 37.3792 21.0439 37.0244 20.8877C36.6729 20.7282 36.3945 20.5231 36.1895 20.2725C35.9844 20.0186 35.8493 19.7533 35.7842 19.4766C35.6898 19.0664 35.6426 18.4609 35.6426 17.6602V13.8418Z"
          fill="#009EE0"/>
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M54.6982 14H63.6982V16H54.6982V14ZM54.6982 20H63.6982V22H54.6982V20ZM66.6982 17H57.6982V19H66.6982V17Z"
            fill="#009EE0"/>
      <rect x="1.19824" y="0.5" width="79" height="35" stroke="#009EE0"/>
    </svg>

    <svg v-if="getOpenMenu" @click="switchMenu(false)" class="mob-btn" viewBox="0 0 81 36" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
          d="M16.5059 18.3682L17.9072 18.8125C17.6924 19.5938 17.3343 20.1748 16.833 20.5557C16.335 20.9333 15.7018 21.1221 14.9336 21.1221C13.9831 21.1221 13.2018 20.7982 12.5898 20.1504C11.9779 19.4993 11.6719 18.6107 11.6719 17.4844C11.6719 16.293 11.9795 15.3685 12.5947 14.7109C13.21 14.0501 14.0189 13.7197 15.0215 13.7197C15.8971 13.7197 16.6084 13.9785 17.1553 14.4961C17.4808 14.8021 17.7249 15.2415 17.8877 15.8145L16.457 16.1562C16.3724 15.7852 16.195 15.4922 15.9248 15.2773C15.6579 15.0625 15.3324 14.9551 14.9482 14.9551C14.4176 14.9551 13.9863 15.1455 13.6543 15.5264C13.3255 15.9072 13.1611 16.5241 13.1611 17.377C13.1611 18.2819 13.3239 18.9264 13.6494 19.3105C13.9749 19.6947 14.3981 19.8867 14.9189 19.8867C15.3031 19.8867 15.6335 19.7646 15.9102 19.5205C16.1868 19.2764 16.3854 18.8923 16.5059 18.3682ZM19.1914 21V13.9004H20.6367V19.7939H24.2305V21H19.1914ZM24.9727 17.4648C24.9727 16.7357 25.0817 16.1237 25.2998 15.6289C25.4626 15.2643 25.6839 14.9372 25.9639 14.6475C26.2471 14.3577 26.5563 14.1429 26.8916 14.0029C27.3376 13.8141 27.8519 13.7197 28.4346 13.7197C29.4893 13.7197 30.3324 14.0469 30.9639 14.7012C31.5986 15.3555 31.916 16.2653 31.916 17.4307C31.916 18.5863 31.6019 19.4912 30.9736 20.1455C30.3454 20.7965 29.5055 21.1221 28.4541 21.1221C27.3896 21.1221 26.5433 20.7982 25.915 20.1504C25.2868 19.4993 24.9727 18.6042 24.9727 17.4648ZM26.4619 17.416C26.4619 18.2266 26.6491 18.8418 27.0234 19.2617C27.3978 19.6784 27.873 19.8867 28.4492 19.8867C29.0254 19.8867 29.4974 19.68 29.8652 19.2666C30.2363 18.8499 30.4219 18.2266 30.4219 17.3965C30.4219 16.5762 30.2412 15.9642 29.8799 15.5605C29.5218 15.1569 29.0449 14.9551 28.4492 14.9551C27.8535 14.9551 27.3734 15.1602 27.0088 15.5703C26.6442 15.9772 26.4619 16.5924 26.4619 17.416ZM32.6826 18.6709L34.0889 18.5342C34.1735 19.0062 34.3444 19.3529 34.6016 19.5742C34.862 19.7956 35.2119 19.9062 35.6514 19.9062C36.1169 19.9062 36.4668 19.8086 36.7012 19.6133C36.9388 19.4147 37.0576 19.1836 37.0576 18.9199C37.0576 18.7507 37.0072 18.6074 36.9062 18.4902C36.8086 18.3698 36.6361 18.2656 36.3887 18.1777C36.2194 18.1191 35.8337 18.015 35.2314 17.8652C34.4567 17.6732 33.9131 17.4372 33.6006 17.1572C33.1611 16.7633 32.9414 16.2832 32.9414 15.7168C32.9414 15.3522 33.0439 15.012 33.249 14.6963C33.4574 14.3773 33.7552 14.1348 34.1426 13.9688C34.5332 13.8027 35.0036 13.7197 35.5537 13.7197C36.4521 13.7197 37.1276 13.9167 37.5801 14.3105C38.0358 14.7044 38.2751 15.2301 38.2979 15.8877L36.8525 15.9512C36.7907 15.5833 36.6572 15.3197 36.4521 15.1602C36.2503 14.9974 35.946 14.916 35.5391 14.916C35.1191 14.916 34.7904 15.0023 34.5527 15.1748C34.3997 15.2855 34.3232 15.4336 34.3232 15.6191C34.3232 15.7884 34.3949 15.9333 34.5381 16.0537C34.7204 16.2067 35.1631 16.3662 35.8662 16.5322C36.5693 16.6982 37.0885 16.8708 37.4238 17.0498C37.7624 17.2256 38.026 17.4681 38.2148 17.7773C38.4069 18.0833 38.5029 18.4626 38.5029 18.915C38.5029 19.3252 38.389 19.7093 38.1611 20.0674C37.9333 20.4255 37.611 20.6924 37.1943 20.8682C36.7777 21.0407 36.2585 21.127 35.6367 21.127C34.7318 21.127 34.0368 20.9186 33.5518 20.502C33.0667 20.082 32.777 19.4717 32.6826 18.6709ZM39.7188 21V13.8418H45.0264V15.0527H41.1641V16.6396H44.7578V17.8457H41.1641V19.7939H45.1631V21H39.7188Z"
          fill="#009EE0"/>
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M62.1982 16.5858L59.7233 14.1109L58.3091 15.5252L60.784 18L58.3091 20.4749L59.7233 21.8891L62.1982 19.4143L64.673 21.8891L66.0873 20.4749L63.6124 18L66.0873 15.5252L64.6731 14.1109L62.1982 16.5858Z"
            fill="#009EE0"/>
      <rect x="1.19824" y="0.5" width="79" height="35" stroke="#009EE0"/>
    </svg>

    <div class="mob-menu" v-if="getOpenMenu">
      <div class="scroll">
        <div class="grey">
          <nav class="links-mob" @click="switchMenu(false)">
            <router-link :class="[{ activeLink: getActiveLink === 'home' }]" to="/#home">Home</router-link>
            <router-link :class="[{ activeLink: getActiveLink === 'about-us' }]" to="/#about-us">about us</router-link>
            <router-link :class="[{ activeLink: getActiveLink === 'management' }]" to="/#management">MANAGEMENT
            </router-link>
            <a href="https://farmak.ch/products-uk-ireland/" target="_blank">products</a>
            <router-link to="/#carbon-statement"
                         :class="[{ activeLink: getActiveLink === 'carbon-statement' }]">
              Carbon Emissions Statement
            </router-link>
            <router-link to="/#slavery-statement-2024"
                         :class="[{ activeLink: getActiveLink === 'slavery-statement-2024' }]">
              Modern Slavery Statement for
              the Financial Year 2024
            </router-link>
            <router-link :class="[{ activeLink: getActiveLink === 'contact' }]" to="/#contact">Contact</router-link>
          </nav>

          <div class="country">
            <div class="line" @click="drop = !drop" v-bind:class="[{ active: drop }]">
              <div class="title">Country</div>
              <div class="current">Uk
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.39648 10.6286L4.39648 5.37133L12.3965 5.37133L8.39648 10.6286Z" fill="#231F20"/>
                </svg>
              </div>
            </div>
            <div v-if="drop" class="hide">
              <a @click="switchMenu(false); drop = false" href="https://www.farmak.co.cz/"
                 target="_blank">Czechia</a>
              <a @click="switchMenu(false); drop = false" href="https://farmakinternational.pl/"
                 target="_blank">Poland</a>
              <a @click="switchMenu(false); drop = false" href="https://farmak.sk/"
                 target="_blank">Slovakia</a>
              <a @click="switchMenu(false); drop = false" href="https://farmak.es/"
                 target="_blank">Spain</a>
              <a @click="switchMenu(false); drop = false" href="https://www.farmak.ch/"
                 target="_blank">Switzerland</a>
              <a @click="switchMenu(false); drop = false" href="https://farmak.ae/" target="_blank">UAE</a>
              <a @click="switchMenu(false); drop = false" href="https://farmak.ua/en/worldwide/"
                 target="_blank">Ukraine</a>

            </div>
          </div>
        </div>
        <div class="blue">
          <div class="title">Contact us</div>
          <div class="address">Farmak Pharmaceuticals UK Ltd<br>
            First Floor, Wykeland House<br>
            47 Queen Street<br>
            Hull, HU1 1UU<br>
            United Kingdom
          </div>
          <a class="mail" href="mailto:info@farmak.uk">info@farmak.uk </a>
        </div>
        <div class="last">
          <div class="content">
            <p class="copy"><a>Copyright © {{ currentYear }} Farmak International. All Rights Reserved.</a></p>
            <p class="ethics-line"><a href="https://report.whistleb.com/en/farmakinternational" target="_blank">Ethics Line</a></p>
            <p class="privacy"><a href="/Privacy_notice_Farmak.ch.pdf" target="_blank">Privacy policy</a></p>
            <p class="inch"><a href="https://inchkiev.ua/" target="_blank">Created by INCHKYIV</a></p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import router from "@/router";

export default {
  name: 'top',
  computed: {
    ...mapGetters(['getActiveLink', 'getOpenMenu'])
  },
  methods: {
    goToLink(link) {
      this.$router.push('/#' + link)
      this.menuDrop = false
    },
    ...mapActions(['switchMenu'])
  },
  data: () => ({
    drop: false,
    menuDrop: false,
    currentYear: new Date().getFullYear()
  }),
}
</script>

<style scoped lang="scss">
@import "@/assets/style/styles";

.top {
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  max-width: 50%;
  width: 100%;
  background: $black-10;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;

  @media screen and (max-width: 1080px) {
    max-width: 100%;
    padding: 20px 24px 8px 24px;
  }

  .logo {
    margin-right: 15px;

    svg {
      max-width: 87px;
      min-width: 87px;
      height: auto;
      width: 100%;
      display: block;

      @media screen and (max-width: 1080px) {
        max-width: 64px;
        min-width: 64px;
      }
    }
  }

  .links {
    display: flex;
    max-width: 614px;
    width: 100%;

    @media screen and (max-width: 1080px) {
      display: none;
    }

    a {
      font-family: $bold;
      font-size: 12px;

      line-height: 136%;
      opacity: 0.6;
      color: $black-100;
      text-decoration: none;
      margin: 0 14px;
      transition: opacity .2s ease;
      letter-spacing: -0.02em;
      text-transform: uppercase;

      height: 30px;
      display: flex;
      align-items: center;

      @media screen and (max-width: 1360px) {
        margin: 0 7px;
      }
      @media screen and (max-width: 1250px) {
        font-size: 11px;
        margin: 0 6px;
      }
      @media screen and (max-width: 1190px) {
        margin: 0 4px;
      }
      @media screen and (max-width: 1110px) {
        font-size: 10px;
      }


      &.activeLink {
        opacity: 1;
      }

      @media screen and (min-width: 1240px) {
        &:hover {
          opacity: 1;
        }
      }

      &:last-child {
        margin-right: 0;
      }

      &:first-child {
        margin-left: 0;
      }
    }
  }

  .mob-btn {
    display: none;

    width: 81px;
    height: auto;

    @media screen and (max-width: 1080px) {
      display: block;
    }
  }

  .mob-menu {
    position: fixed;
    top: 62px;
    left: 0;
    right: 0;
    max-height: calc(((var(--vhMenu, 1vh) * 100) - 61px));

    width: 100%;

    z-index: 100;

    background: $black-10;
    display: none;

    overflow-y: auto;

    @media screen and (max-width: 1080px) {
      display: flex;
    }

    .scroll {
      display: flex;
      flex-direction: column;
      max-height: calc(((var(--vhMenu, 1vh) * 100) - 61px));

      height: 100%;
      width: 100%;
      overflow-y: scroll;
    }

    .links-mob {
      display: flex;
      flex-direction: column;

      a {
        padding: 16px 20px;
        text-transform: uppercase;
        font-family: $bold;
        font-size: 18px;
        line-height: 120%;
        color: $black-100;
        text-decoration: none;
      }
    }

    .country {

      .line {
        padding: 16px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.active {

          background: white;

          .current {
            svg {
              transform: rotate(180deg);
            }
          }
        }

        .title {
          font-size: 18px;
          text-transform: uppercase;
          color: $black-100;
          opacity: 0.5;
          font-family: $bold;
          line-height: 120%;
        }

        .current {
          display: flex;
          align-items: center;
          font-size: 18px;

          font-family: $bold;
          color: $black-100;
          text-transform: uppercase;
          line-height: 120%;

          svg {
            width: 17px;
            height: auto;
            display: block;
            margin-left: 16px;
            transition: transform .2s ease;
          }
        }
      }

      .hide {
        display: flex;
        flex-direction: column;


        a {
          padding: 16px 20px;
          font-size: 14px;
          text-decoration: none;
          font-family: $bold;
          text-transform: uppercase;
          line-height: 120%;
          color: $black-100;
        }
      }
    }

    .blue {
      margin: auto 0 0 0;
      width: 100%;
      background: $blue-50;
      position: relative;
      padding: 20px 20px 32px 20px;

      .title {
        font-family: $bold;
        font-size: 20px;
        color: white;
        text-transform: uppercase;
        margin-bottom: 16px;
        line-height: 120%;
      }

      .text {
        font-family: $bold;
        font-size: 14px;
        line-height: 120%;
        color: white;
        margin-bottom: 22px;
      }

      .address {
        color: $white;
        font-size: 14px;
        font-family: $bold;
        line-height: 120%;
        letter-spacing: -0.04em;
        margin-bottom: 20px;
      }

      .mail {
        transition: border-color .2s ease;
        border-radius: 44px;
        padding: 12px 17px;

        text-decoration: none;
        color: $white;
        font-size: 12px;
        font-family: $bold;
        text-transform: uppercase;
        background: $blue-50;

        letter-spacing: -0.02em;

        height: 52px;

        display: flex;
        justify-content: center;
        align-items: center;

        background: rgba(255, 255, 255, 0.20);
        margin-bottom: 10px;
      }

      .line {
        width: 100%;
        height: 2px;
        background: white;
        margin-bottom: 16px;
      }

      .sales-mail {
        position: relative;
        font-size: 15px;
        line-height: 120%;
        font-family: $bold;
        color: $white;

        display: inline-flex;
        align-items: center;
        text-decoration: none;
        letter-spacing: -0.04em;


        svg {
          display: block;
          width: 14px;
          height: auto;
          margin-left: 10px;
        }

        &:before {
          content: '';
          width: 100%;
          height: 2px;
          bottom: -4px;
          left: 0;
          right: 0;
          position: absolute;

          background: $white;
        }
      }
    }

    .last {
      background: $blue-60;
      padding: 16px 20px;

      display: flex;
      justify-content: center;

      align-items: center;

      .content {
        max-width: 1280px;
        width: 100%;

        display: grid;
        grid-template-columns: auto auto auto;
        justify-content: space-between;

        p, a {
          line-height: 130%;
          font-size: 14px;

          color: $white;
          font-family: $bold;
          text-decoration: none;

          display: flex;
          align-items: center;
        }

        > p:not(.copy) {
          grid-row: 2;
          padding-top: 32px;
          white-space: nowrap;
          font-size: 12px;

          a {
            font-size: inherit;
          }
        }

        > .ethics-line {
          grid-column: 2;
          justify-self: center;
        }

        > .privacy {
          grid-column: 1;
        }

        > .inch {
          grid-column: 3;
          justify-self: end;
        }

        > .copy {
          grid-column: 1 / -1;
        }
      }
    }
  }

  .drop-desk {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    @media screen and (min-width: 1024px) {
      &:hover {
        .drop-desk__hide {
          opacity: 1 !important;
          pointer-events: visible;
        }

        > svg {
          transform: rotate(180deg);
        }
      }
    }

    &.activeDrop {
      svg {
        transform: rotate(180deg);
      }
    }

    svg {
      transition: transform .2s ease;
      display: block;
      margin-left: 4px;
      margin-top: -3px;

    }

    &__hide {
      position: absolute;
      right: 0;
      top: 28px;
      opacity: 0 !important;
      pointer-events: none;

      width: 177px;
      padding: 12px 24px 24px 24px;

      background: #FFF;
      box-shadow: 20px 20px 40px 0 rgba(0, 0, 0, 0.15);

      span {
        display: block;
      }

      a {
        margin-left: 0;
        margin-right: 0;
        display: inline-block;
        height: auto;

        @media screen and (min-width: 1024px) {
          &:hover {
            border-color: #038FD0 !important;
            color: #038FD0;
          }
        }

        &:first-child {
          border-top: 1px solid rgba(35, 31, 32, 0);
          padding-top: 12px;
        }

        &:last-child {
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid rgba(35, 31, 32, 0);
        }
      }
    }
  }
}
</style>
